export const range = (start: number, end: number): number[] => {
  let length = Math.max(end - start, 0);
  const result: number[] = [];

  while (length--) {
    result[length] = start + length;
  }

  return result;
};

export const chunk = (array: any[], size: number): any[][] => {
  const length = array.length;
  let index = 0;
  let resIndex = -1;
  const result: any[][] = [];

  while (index < length) {
    result[++resIndex] = array.slice(index, (index += size));
  }

  return result;
};
